/**
 * @deprecated use `unlessW`
 */

/**
 * @deprecated use `unlessW`
 */
export function unless(predicate, onFailure) {
  return function (value) {
    return predicate(value) ? value : onFailure(value);
  };
}
export function unlessW(predicate, onFailure) {
  return function (value) {
    return predicate(value) ? value : onFailure(value);
  };
}